import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DeleteAccount.css';

export const DeleteAccount = () => {
    const { t } = useTranslation();
    const [selectedProfile, setSelectedProfile] = useState(null);

    const handleProfileSelect = (profileType) => {
        setSelectedProfile(profileType);
    };

    return (
        <div className="delete-account-container">
            <div className="delete-account-content">
                <header className="delete-account-header">
                    <h1>{t('deleteAccount.header')}</h1>
                    <p className="delete-account-description">
                        {t('deleteAccount.description')}
                    </p>
                </header>

                <section className="profile-selection">
                    <h2>{t('deleteAccount.profileTypes.title')}</h2>
                    <div className="profile-options">
                        <div
                            className={`profile-option ${selectedProfile === 'glitter' ? 'selected' : ''}`}
                            onClick={() => handleProfileSelect('glitter')}
                        >
                            <div className="profile-icon">
                                {t('deleteAccount.profileTypes.glitter.icon')}
                            </div>
                            <div className="profile-info">
                                <h3>{t('deleteAccount.profileTypes.glitter.title')}</h3>
                                <p>{t('deleteAccount.profileTypes.glitter.description')}</p>
                            </div>
                        </div>

                        <div
                            className={`profile-option ${selectedProfile === 'customer' ? 'selected' : ''}`}
                            onClick={() => handleProfileSelect('customer')}
                        >
                            <div className="profile-icon">
                                {t('deleteAccount.profileTypes.customer.icon')}
                            </div>
                            <div className="profile-info">
                                <h3>{t('deleteAccount.profileTypes.customer.title')}</h3>
                                <p>{t('deleteAccount.profileTypes.customer.description')}</p>
                            </div>
                        </div>
                    </div>
                </section>

                {selectedProfile && (
                    <section className="deletion-guide">
                        <h2>{t('deleteAccount.deletionGuide.title')}</h2>

                        <div className="guide-steps">
                            <div className="step">
                                <div className="step-number">1</div>
                                <div className="step-content">
                                    <h3>{t('deleteAccount.deletionGuide.step1.title')}</h3>
                                    <p>{t('deleteAccount.deletionGuide.step1.description')}</p>
                                    <div className="step-details">
                                        <strong>{t('deleteAccount.deletionGuide.step1.path')}</strong>
                                    </div>
                                </div>
                            </div>

                            <div className="step">
                                <div className="step-number">2</div>
                                <div className="step-content">
                                    <h3>{t('deleteAccount.deletionGuide.step2.title')}</h3>
                                    <p>{t('deleteAccount.deletionGuide.step2.description')}</p>
                                </div>
                            </div>

                            <div className="step">
                                <div className="step-number">3</div>
                                <div className="step-content">
                                    <h3>{t('deleteAccount.deletionGuide.step3.title')}</h3>
                                    <p>{t('deleteAccount.deletionGuide.step3.description')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="alternative-method">
                            <h3>{t('deleteAccount.deletionGuide.alternative.title')}</h3>
                            <p>{t('deleteAccount.deletionGuide.alternative.description')}</p>
                            <div className="email-info">
                                <strong>{t('deleteAccount.deletionGuide.alternative.email')}</strong>
                                <span className="email-address">{t('deleteAccount.contactEmail')}</span>
                            </div>
                        </div>
                    </section>
                )}

                <section className="warning-section">
                    <div className="warning-message">
                        <p>{t('deleteAccount.warning')}</p>
                    </div>
                </section>

                <footer className="delete-account-footer">
                    <p>{t('deleteAccount.footer')}</p>
                    <p className="contact-info">
                        <strong>{t('deleteAccount.contact.label')}:</strong> {t('deleteAccount.contactEmail')}
                    </p>
                </footer>
            </div>
        </div>
    );
};
